export default __webpack_public_path__ + "static/media/peace.9bf8d182.png";